import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { WalletType } from 'types/wallets';
import { API_BASE_BTC_URL } from 'constants/general';
import { formatEther } from 'viem';
import { tracker } from 'utils/tracker';
import { getPublicClient } from 'utils/getPublicClient';
export const useWalletBalance = (address, type) => {
    const [balance, setBalance] = useState(null);
    const [fullBalance, setFullBalance] = useState(null);
    const [lastCheckedChain, setLastCheckedChain] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const publicClient = getPublicClient();
    const fetchBalance = useCallback(async () => {
        if (!address) {
            setBalance(null);
            return;
        }
        setLoading(true);
        setError(null);
        try {
            if (type === WalletType.BTC) {
                const response = await axios.get(`${API_BASE_BTC_URL}/address/${address}`);
                const confirmedBalance = response.data.chain_stats.funded_txo_sum -
                    response.data.chain_stats.spent_txo_sum;
                const unconfirmedBalance = response.data.mempool_stats.funded_txo_sum;
                // Do not continue with calculations if the balance is 0
                if (confirmedBalance === 0 && unconfirmedBalance === 0) {
                    setBalance('0');
                    return;
                }
                const fee = 600 * tracker.store.getState().btcFee;
                const fullBalance = confirmedBalance + unconfirmedBalance;
                const totalBalance = fullBalance - fee;
                setBalance((totalBalance / 1e8).toFixed(8));
                setFullBalance((fullBalance / 1e8).toFixed(8));
            }
            else if (type === WalletType.EVM) {
                const balance = await publicClient.getBalance({
                    address: address,
                });
                setBalance(formatEther(balance));
            }
        }
        catch (err) {
            console.error(`Failed to fetch ${type} balance:`, err);
            setError(`Failed to fetch ${type} balance`);
        }
        finally {
            setLoading(false);
        }
    }, [address, type, publicClient]);
    useEffect(() => {
        if (address &&
            (lastCheckedChain === null || lastCheckedChain !== publicClient.chain.id)) {
            fetchBalance();
            console.log('fetching balance');
            setLastCheckedChain(publicClient.chain.id);
        }
    }, [fetchBalance, address, balance, publicClient.chain, lastCheckedChain]);
    return { balance, fullBalance, error, loading };
};
